// APP CONFIG
export const appConfig = {
  app: {
    appName: process.env.VUE_APP_NAME,
    appDescription: 'Liveet Verify Web',
  },
}
